import React, { useContext, useEffect, useState } from "react";
import { Modal, Form, Select, DatePicker } from "antd";
import { useAtom } from "jotai";
import { visibleModalVerificacionEnvioDocumentoAtom } from "../../ColaboradorListarStore";
import { SecurityContext } from "context/SecurityContextProvider";
import TipoDocumentoService from "services/TipoDocumentoService";
import DetalleEnvioService from "services/DetalleEnvioService";
import { saveAs } from "file-saver";

const ModalReporteVerificacionEnvioDocumento = () => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const [visible, setVisible] = useAtom(visibleModalVerificacionEnvioDocumentoAtom);
	const [tiposDocumento, setTiposDocumento] = useState([]);
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!visible) return;
		const cargarDatosIniciales = async () => {
			try {
				const respuesta = await TipoDocumentoService.listarPorUsuario(getUsuarioAutenticado().login);
				setTiposDocumento(respuesta);
			} catch (error) {
				console.error(error);
			}
		};
		cargarDatosIniciales();
	}, [visible]);

	const onCancelar = () => {
		form.resetFields();
		setVisible(false);
	};

	const onClickExportar = () => {
		form
			.validateFields()
			.then(async (values) => {
				setLoading(true);
				try {
					const parametros = {
						solicitanteId: getUsuarioAutenticado().id,
						organizacionId: getUsuarioAutenticado().organizacionId,
						empresaId: getUsuarioAutenticado().empresaSeleccionada.id,
						login: getUsuarioAutenticado().login,
						tipoDocumentoId: values.tipoDocumentoId,
						periodoDocumento: values.periodoDocumento ? values.periodoDocumento.format("MM/YYYY") : null,
						estadoDocumento: values.estadoDocumento ?? null,
						estadoColaborador: values.estadoColaborador ?? [],
						origen: "ADMIN",
						nombrePagina: "ColaboradorListar",
					};
					const respuesta = await DetalleEnvioService.reporteVerificacionEnvioDocumento(parametros);
					saveAs(respuesta.data, respuesta.headers.filename);
					form.resetFields();
					setVisible(false);
				} catch (error) {
					console.error(error);
				} finally {
					setLoading(false);
				}
			})
			.catch((info) => {
				console.log("Validate Failed:", info);
			});
	};

	return (
		<Modal
			title="Verificar Envío de Documento"
			open={visible}
			okText="Exportar"
			onOk={onClickExportar}
			onCancel={onCancelar}
			confirmLoading={loading}
		>
			<Form form={form} autoComplete="off" layout="vertical">
				<Form.Item
					label="Tipo de Documento"
					name="tipoDocumentoId"
					rules={[{ required: true, message: "Seleccione el tipo de documento" }]}
				>
					<Select
						showSearch
						placeholder="Selecciona el tipo de documento"
						filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
					>
						{tiposDocumento.map((tipoDocumento) => (
							<Select.Option key={tipoDocumento.id} value={tipoDocumento.id}>
								{tipoDocumento.nombre}
							</Select.Option>
						))}
					</Select>
				</Form.Item>

				<Form.Item label="Periodo Documento" name="periodoDocumento">
					<DatePicker picker="month" format="MM/YYYY" style={{ width: "100%" }} />
				</Form.Item>

				<Form.Item label="Estado Documento" name="estadoDocumento">
					<Select allowClear showSearch placeholder="Seleccione el estado del documento (todos por defecto)">
						<Select.Option value={"PENDIENTE"}>PENDIENTE</Select.Option>
						<Select.Option value={"VISUALIZADO"}>VISUALIZADO</Select.Option>
						<Select.Option value={"SIN_VISUALIZAR"}>SIN VISUALIZAR</Select.Option>
						<Select.Option value={"FIRMADO"}>FIRMADO</Select.Option>
						<Select.Option value={"ERROR"}>ERROR</Select.Option>
					</Select>
				</Form.Item>

				<Form.Item label="Estado del Colaborador" name="estadoColaborador">
					<Select
						allowClear
						showSearch
						mode="multiple"
						placeholder="Seleccione el estado del colaborador (todos por defecto)"
					>
						<Select.Option value={"ONBOARDING"}>ONBOARDING</Select.Option>
						<Select.Option value={"ACTIVO"}>ACTIVO</Select.Option>
						<Select.Option value={"CESADO"}>CESADO</Select.Option>
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default ModalReporteVerificacionEnvioDocumento;
